export function getApiEndpoint(): string {
  return window.location.origin;
}
